import { QueryClient } from '@tanstack/react-query';
import { QUERY_TIER_DEFAULTS } from '@/lib/query';

/** Global QueryClient — operational tier as default; per-query tierOptions() overrides. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...QUERY_TIER_DEFAULTS.operational,
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
